$(document).ready(function(){
	// var rellax = new Rellax('.rellax');		
});

$(document).foundation();